import { HrisIntegrationResponseState } from './hris-integration-response-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import {
  Action,
  StateStatus,
  setStateDirtyByParam,
  updateResourceByObjectKey,
} from '../reducers/utils/state-manager';

const InitialState: HrisIntegrationResponseState = {
  hrisIntegrationResponsesByOrgId: {},
  hrisIntegrationResponsesStateByOrgId: {},
};

export const hrisIntegrationResponseReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('LOAD_HRIS_INTEGRATION_RESPONSE'): {
      const { orgId } = action.payload.args;
      return updateResourceByObjectKey(state, 'hrisIntegrationResponsesByOrgId', orgId, true);
    }
    case SUCCESS('LOAD_HRIS_INTEGRATION_RESPONSE'): {
      const {
        payload: {
          args: { orgId },
          data,
        },
      } = action;
      return data && Object.keys(data).length
        ? updateResourceByObjectKey(state, 'hrisIntegrationResponsesByOrgId', orgId, false, {
            [orgId]: data,
          })
        : {
            ...state,
            hrisIntegrationResponsesStateByOrgId: {
              ...state.hrisIntegrationResponsesStateByOrgId,
              [orgId]: StateStatus.success,
            },
          };
    }
    case FAILURE('LOAD_HRIS_INTEGRATION_RESPONSE'): {
      const { orgId } = action.payload.args;
      return updateResourceByObjectKey(state, 'hrisIntegrationResponsesByOrgId', orgId, false);
    }
    case STARTING('CREATE_HRIS_INTEGRATION_RESPONSE'): {
      const { orgId } = action.payload.args.hrisIntegrationResponse;
      return updateResourceByObjectKey(state, 'hrisIntegrationResponsesByOrgId', orgId, true);
    }
    case SUCCESS('CREATE_HRIS_INTEGRATION_RESPONSE'): {
      const { data } = action.payload;
      const { orgId } = data;

      return updateResourceByObjectKey(state, 'hrisIntegrationResponsesByOrgId', orgId, false, {
        [orgId]: data,
      });
    }
    case STARTING('UPDATE_HRIS_INTEGRATION_RESPONSE'): {
      const { orgId } = action.payload.args.update;
      return updateResourceByObjectKey(state, 'hrisIntegrationResponsesByOrgId', orgId, true);
    }
    case SUCCESS('UPDATE_HRIS_INTEGRATION_RESPONSE'): {
      const {
        payload: {
          args: {
            update: { orgId },
          },
          data,
        },
      } = action;

      return updateResourceByObjectKey(state, 'hrisIntegrationResponsesByOrgId', orgId, false, {
        [orgId]: data,
      });
    }
    case 'SET_HRIS_INTEGRATION_RESPONSE_DIRTY': {
      const { orgId } = action.payload.args;
      return setStateDirtyByParam(state, 'hrisIntegrationResponses', 'orgId', orgId);
    }
    default: {
      return state;
    }
  }
};
